export enum SelectionManagerEventType {
  CHANGE = "change",
  ADD = "add",
  REMOVE = "remove",
}

export default SelectionManagerEventType;
